import Config from 'utils/getEnvConfig';
import {
  ApolloLink,
  HttpLink,
  ApolloClient,
  InMemoryCache,
} from '@apollo/client';

import { onError } from '@apollo/client/link/error';
import { apiCatch } from 'utils/sentryApiCatch';
import { RetryLink } from '@apollo/client/link/retry';
const { SPACE_ID, ACCESS_TOKEN, ENVIRONMENT } = Config.CONTENTFUL;
const retryLink = new RetryLink();

const httpLink = new HttpLink({
  uri: `https://graphql.contentful.com/content/v1/spaces/${SPACE_ID}/environments/${ENVIRONMENT}`,
  headers: {
    authorization: `Bearer ${ACCESS_TOKEN}`,
  },
});

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      apiCatch(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      ),
    );
});

const link = ApolloLink.from([retryLink, errorLink, httpLink]);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

export default client;
